module.exports = __webpack_public_path__ + "static/img/value.427e3177.png";